import React from "react";
import { Spinner } from "react-bootstrap";
import "./ViewAssessmentVideo.scss";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faAngleLeft,
  faPencil,
  faXmark,
  faCheck,
} from "@fortawesome/free-solid-svg-icons";
import VideoPlayer from "../../../_uiComponents/VideoPlayerBasic";
import StarRatings from "react-star-ratings";
import useViewAssessmentVideo from "./useViewAssessmentVideo";
import MainLayout from "../MainLayout";
function ViewAssessmentVideoNew(props) {
  const {
    interviewKitReview,
    question,
    loading,
    isPublicApi,
    defaultRemark,
    isEditRemark,
    userMeta,
    questionIndex,
    onQuestionRatingChange,
    onBlurInput,
    onEditRemark,
    onNavigateBack,
    onQuestionViewClick,
    onClickShortlist,
    onNextPrevClick,
  } = useViewAssessmentVideo(props);

  return (
    <MainLayout pageName={"View Assessment Videos"}>
      <div className="view-assessment-video">
        {loading ? (
          <div className="p-5 text-center">
            <Spinner animation="border" variant="primary" />
          </div>
        ) : (
          <div>
            {Array.isArray(interviewKitReview) &&
            interviewKitReview.length > 0 ? (
              <div className="view-interview-wrapper">
                <div className="container">
                  <div className="player-wrapper pb-2">
                    <div className="row flex-grow-1">
                      {question && (
                        <div className="interview-video col-lg-8">
                          <div className="border bg-white border-radius-10 p-3 shadow-2 mt-3 mb-md-4">
                            <div className="d-flex justify-content-between flex-wrap flex-md-nowrap">
                              <div className="d-flex align-items-center">
                                <FontAwesomeIcon
                                  onClick={onNavigateBack}
                                  className="text-grey-4 mr-3 cursor-pointer h2"
                                  icon={faAngleLeft}
                                />
                                <div className="d-flex align-items-center">
                                  <img
                                    src={
                                      question?.candidate_profile_detail &&
                                      question.candidate_profile_detail
                                        ?.user_details &&
                                      question.candidate_profile_detail
                                        .user_details?.user_meta_info &&
                                      question.candidate_profile_detail
                                        .user_details.user_meta_info
                                        ?.profile_image
                                        ? question?.candidate_profile_detail &&
                                          question.candidate_profile_detail
                                            ?.user_details &&
                                          question.candidate_profile_detail
                                            .user_details?.user_meta_info &&
                                          question.candidate_profile_detail
                                            .user_details.user_meta_info
                                            ?.profile_image
                                        : "/assets/images/user.png"
                                    }
                                    alt="candidate"
                                    style={{ width: "50px", height: "50px" }}
                                    className="border-radius-10"
                                  />
                                  <div className="info mx-3 text-capitalize">
                                    <h3>
                                      {question?.candidate_profile_detail &&
                                        question.candidate_profile_detail
                                          ?.user_details &&
                                        question.candidate_profile_detail
                                          .user_details?.full_name}
                                    </h3>
                                    <p className="text-grey-4 fs-14 mb-0">
                                      {question?.candidate_profile_detail &&
                                        question.candidate_profile_detail
                                          ?.user_details &&
                                        question.candidate_profile_detail
                                          .user_details?.headline}
                                    </p>
                                  </div>
                                </div>
                              </div>

                              <div className="d-flex align-items-start justify-content-between">
                                <div className="d-flex">
                                  {/* <button className="btn btn-outline-danger d-flex align-items-center">
                                    <FontAwesomeIcon icon={faXmark} className="font-weight-medium mr-md-2 p-2 p-md-0" /> <span className="d-none d-md-block">Reject</span>
                                  </button> */}
                                  {/* <button className={`btn ${question?.is_shortlisted ? "btn-success" : "btn-outline-success"} ml-3 d-flex align-items-center`}
                                    onClick={() =>
                                      onClickShortlist(userMeta?.id)
                                    }>
                                    <FontAwesomeIcon icon={faCheck} className="font-weight-medium mr-md-2 p-2 p-md-0" /><span className="d-none d-md-block">
                                    {question?.is_shortlisted ?"Shortlisted" : "Shortlist"}</span>
                                  </button> */}
                                </div>
                              </div>
                            </div>

                            <div className="mt-3 border-top py-3 fs-14 d-flex align-items-center flex-wrap">
                              <div className="bg-grey p-1 border rounded-pill mr-3">
                                <p className="text-primary rounded-pill mb-0 border px-2 py-1 bg-light-blue border-primary text-capitalize d-inline mr-2">
                                  {question?.question_detail &&
                                    question.question_detail?.topic_name}
                                </p>
                                <span className="d-inline-block rounded-pill py-1 px-2 text-capitalize">
                                  {question?.question_detail &&
                                    question.question_detail?.skill_names &&
                                    question.question_detail?.skill_names[0]}
                                </span>
                              </div>
                              <div className="d-none d-md-block">
                                <StarRatings
                                  rating={
                                    question?.rating &&
                                    question.rating?.rating === null
                                      ? 0
                                      : question?.rating &&
                                        question.rating?.rating
                                  }
                                  starRatedColor="#FFCC2A"
                                  changeRating={(e) =>
                                    onQuestionRatingChange(e)
                                  }
                                  numberOfStars={5}
                                  name="rating"
                                  starDimension="24"
                                  starHoverColor="#FCDDB0"
                                  starSpacing="2px"
                                />
                              </div>
                            </div>
                            <div className="question-wrapper d-flex  justify-content-center text-grey-1">
                              <span className="select form-group w-100">
                                <select
                                  className="form-control bg-transparent border-radius-10"
                                  name="questions"
                                  value={
                                    question?.question_detail?.question || ""
                                  }
                                  onChange={onQuestionViewClick}
                                >
                                  {interviewKitReview &&
                                    interviewKitReview.map((item, index) => (
                                      <option
                                        key={item?.question_detail?.id}
                                        value={item?.question_detail?.question}
                                      >
                                        {item?.question_detail?.question}
                                      </option>
                                    ))}
                                </select>
                              </span>
                            </div>
                            <div className="video-wrapper border-radius-10">
                              <VideoPlayer
                                playbackId={question?.video_asset_id}
                                isAutoPlay={true}
                                height={400}
                              />
                            </div>
                          </div>
                        </div>
                      )}

                      {question && (
                        <div className="col-lg-4 mt-3 mb-4 mb-md-4">
                          <div className="border bg-white border-radius-10 p-3 shadow-2 h-100 mb-md-4 position-relative">
                            <div className="question-panel position-relative">
                              <div className="form-group mt-2 w-100">
                                <label
                                  htmlFor=""
                                  className="mb-2 font-weight-medium fs-14"
                                >
                                  {defaultRemark?.remark ? "Added" : "Add"}{" "}
                                  Assessment Kit Remark
                                </label>
                                {userMeta?.role === "hiring_manager" ? (
                                  <p>{defaultRemark?.remark}</p>
                                ) : defaultRemark?.remark ? (
                                  <div className="my-2">
                                    <span>{defaultRemark?.remark}</span>
                                    <FontAwesomeIcon
                                      icon={isEditRemark ? faXmark : faPencil}
                                      className="cursor-pointer text-grey-4 ml-2"
                                      onClick={() => onEditRemark()}
                                    />
                                  </div>
                                ) : null}
                                {!defaultRemark?.remark || isEditRemark ? (
                                  <textarea
                                    className="form-control h-auto bg-white border-radius-10"
                                    placeholder="Add Remark Here"
                                    rows="5"
                                    onBlur={(e) => onBlurInput(e)}
                                    name="remark"
                                    defaultValue={defaultRemark?.remark}
                                  ></textarea>
                                ) : null}
                              </div>
                            </div>
                            <button
                              className="next-btn btn btn-primary ml-3 position-absolute d-none d-md-block"
                              disabled={
                                questionIndex === interviewKitReview.length - 1
                              }
                              onClick={() =>
                                onNextPrevClick(question?.id, "add")
                              }
                            >
                              Next
                            </button>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
                <div className="bottom d-flex d-md-none align-items-center justify-content-between bg-white border-top p-3 position-fixed w-100">
                  <StarRatings
                    rating={
                      question?.rating && question.rating?.rating === null
                        ? 0
                        : question?.rating && question.rating?.rating
                    }
                    starRatedColor="#FFCC2A"
                    changeRating={(e) => onQuestionRatingChange(e)}
                    numberOfStars={5}
                    name="rating"
                    starDimension="24"
                    starHoverColor="#FCDDB0"
                    starSpacing="2px"
                  />
                  <button
                    className="btn btn-primary ml-3"
                    disabled={questionIndex === interviewKitReview.length - 1}
                    onClick={() => onNextPrevClick(question?.id, "add")}
                  >
                    Next
                  </button>
                </div>
              </div>
            ) : (
              <div className="view-interview-wrapper">
                <p className="question d-flex justify-content-center flex-wrap font-weight-medium mb-0 pt-5 ">
                  {isPublicApi
                    ? "None of the questions are marked as public ."
                    : "Candidate has not submitted the interview kit yet."}
                </p>
              </div>
            )}
          </div>
        )}
      </div>
    </MainLayout>
  );
}
export default ViewAssessmentVideoNew;
